<script setup lang="ts">
import { onBeforeMount } from 'vue';
import BaseButton from './BaseButton.vue'
import { useNavigator } from '@/hooks'

const boundValue = defineModel()
const props = defineProps<{
  tabItems: {
    label: string
    action?: () => void
  }[]
  disabled?: boolean
  hasNavigate?: boolean
}>()
const emit = defineEmits(['change'])

const navigator = useNavigator()

const path = navigator.getCurrentRoute().path
const pathHash = navigator.getCurrentRoute().hash.slice(1)

async function setCurrentTab(item: any) {
  if (props.disabled) return
  emit('change', item.value, boundValue.value)
  boundValue.value = item.label
  item.action?.()
}

onBeforeMount(() => {
  if (!props.hasNavigate) return
  // const currentTab = props.tabItems[Number(pathHash)]
  const currentTab = props.tabItems.find(tab => tab.label === pathHash);
  if (currentTab) {
    setCurrentTab(currentTab);
  }
})
</script>
<template>
  <div class="d-flex ga-3 w-100 text-center">
    <BaseButton
      v-for="(item, index) in tabItems"
      :key="index"
      class="base-tab-pd tab-item px-5 py-3 bg-slate_50"
      :class="`body-2 medium ${boundValue == item.label ? 'active-tab' : 'text-slate_600'} ${$attrs?.buttonPadding ? $attrs?.buttonPadding : ''}`"
      :to="hasNavigate ? `${path}#${item.label}` : null"
      @click="setCurrentTab(item)"
      @keypress="setCurrentTab(item)"
    >
      {{ item.label }}
    </BaseButton>
  </div>
</template>
<style scoped lang="scss">
.tab-item {
  min-width: 150px;
  height: 44px;
}
.active-tab {
  color: rgba(var(--v-theme-emerald_600)) !important;
  border-bottom: 2px solid rgb(var(--v-theme-emerald_600));
}
[disabled='true'] {
  border: 1.5px solid var(--v-black_25-base) !important;
  .active-tab {
    background-color: var(--v-black_25-base) !important;
    background: var(--v-black_25-base) !important;
  }
}

</style>
